import { createSlice } from '@reduxjs/toolkit'

export const counterSlice = createSlice({
  name: 'merchant',
  initialState: {
    "merchantId": "",
    "name": "",
    "tables": [],
    "businessHours": []
  },
  reducers: {
    setMerchant: (state, action) => {
      return action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setMerchant } = counterSlice.actions

export default counterSlice.reducer